import { Navigate } from 'react-router-dom'
import { hasCompletedOnboarding } from '@/lib/onboarding'
import { useAuth } from '@/context/AuthContext'
import { useFamily } from '@/context/FamilyContext'

interface RequireOnboardingProps {
  children: React.ReactNode
}

export function RequireOnboarding({ children }: RequireOnboardingProps) {
  const { user, isLoading: authLoading } = useAuth()
  const { activeWriter, isLoading: familyLoading } = useFamily()

  // Show nothing while loading
  if (authLoading || familyLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--color-kids-bg)]">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[var(--color-kids-primary)] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-[var(--color-kids-text-muted)]">Loading...</p>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  const done = hasCompletedOnboarding({
    userId: user.id,
    childId: activeWriter?.id,
  })

  if (!done) {
    return <Navigate to="/onboarding" replace />
  }

  return <>{children}</>
}
